export const it = {
  aiPlayground: {
    pageTitle: 'Training',
    admin: {
      intro: {
        labelComingSoon: 'Coming soon',
        title: 'Formazione su misura',
        description:
          'La formazione personalizzata crea percorsi di crescita su misura. Partendo dall’assessment delle soft skills, ogni utente riceve suggerimenti mirati e in linea con il proprio profilo, rendendo lo sviluppo più efficace e stimolante.',
        comingDate: 'Lancio previsto: Q1 2026',
      },
      pillars: {
        block1: {
          title: 'Percorsi personalizzati',
          description:
            'Training costruiti sui risultati dell’assessment, con contenuti proporzionati a formato e durata.',
        },
        block2: {
          title: 'Libreria di contenuti',
          description:
            'Oltre 300 contenuti tra video, podcast, workshop, corsi in presenza e articoli interattivi.',
        },
        block3: {
          title: 'AI & Analytics',
          description:
            'L’AI seleziona e valida i contenuti, propone raccomandazioni mirate e aggiorna i progressi nelle dashboard.',
        },
      },
      howDoesItWork: {
        title: 'Come funziona',
        step1: {
          title: 'Visualizza i percorsi ',
          description: 'Scopri i percorsi formativi più adatti a migliorare il tuo profilo.',
        },
        step2: {
          title: '2. Analisi dei risultati',
          description:
            'Dashboard e analytics avanzati mostrano l’evoluzione delle competenze, a livello individuale e di team.',
        },
        step3: {
          title: 'Ricevi raccomandazioni dall’AI',
          description: 'Suggerimenti personalizzati basati sui dati di utilizzo e performance.',
        },
      },
      catalog: {
        title: 'Catalogo attività',
        step1: {
          title: 'Free Resources',
          description:
            'Una sezione aperta che raccoglie contenuti gratuiti sulle soft & hard skills, pensata per avvicinare i dipendenti al training.',
        },
        step2: {
          title: 'Corsi slash online',
          description:
            'Pillole formative da 5-10 minuti, quiz, podcasts e micro-sfide pratiche. Ideali per una fruizione rapida e continua, adattabile ai ritmi di lavoro.',
        },
        step3: {
          title: 'Contenuti esclusivi',
          description:
            'Eventi premium e webinar con esperti, esperienze immersive e storytelling di valore offerti da partner selezionati.',
        },
        step4: {
          title: 'Corsi in presenza',
          description:
            'Workshop e lezioni live che arricchiscono il percorso digitale con momenti esperienziali e di confronto diretto.',
        },
      },
      gamification: {
        title: 'Gamification',
        description:
          'La piattaforma incentiva la partecipazione con un sistema di gamificazione che premia costanza, collaborazione e risultati. Sfide, classifiche e premi rendono l’esperienza formativa più motivante e coinvolgente.',
        block1: {
          title: 'Leaderboard',
          description: 'Classifiche e sfide per stimolare una competizione positiva',
        },
        block2: {
          title: 'Premi e sblocco di contenuti',
          description:
            'I crediti guadagnati permettono di accedere a contenuti esclusivi o eventi speciali.',
        },
        block3: {
          title: 'Badge e certificazioni',
          description: 'Riconoscimenti e attestati al raggiungimento dei traguardi',
        },
      },
      aiPlayground: {
        title: 'AI Playground',
        subTitle: 'Forma i tuoi team già da oggi con l’AI Playground',
        description:
          "In attesa del Training in piattaforma, scopri i percorsi dell'AI Playground by altermAInd: esperienze strategiche e pratiche per introdurre l’intelligenza artificiale in azienda, valorizzando persone, competenze e mindset di crescita.",
        buttonText: 'Scopri il programma',
      },
      landingPlayground: {
        people: 'persone',
        person: 'persona',
        title: 'Percorsi AI Playground per la tua organizzazione ',
        description:
          'Scopri l’AI Playground by altermAInd: percorsi strategici e pratici per introdurre l’intelligenza artificiale in azienda. Il modulo personalizzato trasforma i questionari in piani di crescita su misura, valorizzando le soft skills e offrendo suggerimenti mirati per uno sviluppo efficace e coinvolgente.',
        buttonText: 'Scopri il programma',
        courses: {
          title: 'I nostri corsi',
          tooltip:
            'Sono contrassegnate con “Skill to boost” le due competenze che hanno registrato il punteggio mediamente più basso all’interno dell’organizzazione. Il numero accanto al cuore indica quanti dipendenti hanno mostrato interesse verso ciascun corso.',
          card: {
            skillToBoost: 'Skill to boost',
            initialLevel: 'Livello iniziale',
            participant: 'Persona',
            participants: 'Persone',
            partecipanesTooltip:
              'Persone che hanno totalizzato un punteggio compreso tra 0 e 2 in questa skill',
            departments: 'Dipartimenti',
            departmentsTooltip:
              'Numero di dipartimenti in cui rientrano le persone al livello iniziale',
            buttonLabel: 'Scopri di più',
          },
          detailsDialog: {
            label: 'CORSO',
            description: 'Descrizione',
            buttonLabel: 'Scarica la brochure',
          },
          usersContentsLikesDialog: {
            title: 'Dipendenti interessati',
            description: 'Visualizza i dipendenti interessati all’attività dell’AI Playground',
            table: {
              fullName: 'Nome e Cognome',
              role: 'Ruolo',
              email: 'Email',
            },
            labelAllEmployees: 'Tutti i dipendenti',
          },
        },
        aiPlayground: {
          noResult: {
            title: 'AI Playground',
            subTitle: 'Vuoi far sperimentare ai tuoi\n dipendenti l’AI Playground?',
            subTitleSkill:
              'I tuoi dipendenti faticano in {{name}}? \nAttiva subito il percorso più adatto',
            description: 'Scopri come avviare il percorso più adatto alla tua realtà!',
            descriptionSkill:
              'Dall’assessment emerge che {{count}} {{personLabel}} dell’azienda ha un livello iniziale in {{name}}.\n Contattaci e avvia il training dell’AI Playground più adatto a potenziare questa competenza.',
            buttonLabel: 'Contattaci',
          },
        },
      },
    },
    learning: {
      tutorial: {
        title: 'Scopri come funziona il training sulle soft skills',
        slides: {
          slide1: {
            title: 'Esplora le soft skills',
            description:
              'Consulta l\'elenco delle soft skills disponibili. In base ai risultati del tuo assessment personale, alcune skill possono essere evidenziate come "Skill to boost": sono quelle in cui il tuo punteggio è più basso e che rappresentano le aree con maggiore potenziale di crescita.',
          },
          slide2: {
            title: 'Scopri le attività disponibili',
            description:
              "Per ogni soft skill puoi visualizzare le attività formative in presenza associate. Puoi anche esprimere una preferenza per le attività che ti interessano; questa verrà comunicata automaticamente a HR, che potrà prenderla in considerazione per organizzare eventuali giornate di formazione in presenza per l'azienda.",
          },
        },
      },
      landingPlayground: {
        people: 'persone',
        person: 'persona',
        title: 'Le tue skills hanno bisogno di un boost?',
        description:
          "In questa pagina trovi i percorsi dell'AI Playground by altermAInd più adatti per iniziare ad allenare quelle competenze, con attività coinvolgenti, pratiche e orientate all’impatto reale. Per approfondire i moduli, scarica la brochure completa cliccando su Scopri il programma.\n\n Non appena avrai completato l’assessment, evidenzieremo le skills in cui risulti più carente, per permetterti di selezionare i moduli dell’AI Playground più adatti a migliorarle.",
        buttonText: 'Scopri il programma',
        courses: {
          title: 'I nostri corsi',
          tooltip:
            'Sono contrassegnate con “Skill to boost” le due competenze dell’Actual profile in cui hai ottenuto complessivamente il punteggio più basso.',
          card: {
            skillToBoost: 'Skill to boost',
            buttonLabel: 'Scopri di più',
          },
          detailsDialog: {
            label: 'CORSO',
            description: 'Descrizione',
            buttonLabel: 'Scarica la brochure',
          },
        },
        programs: {
          title: 'Percorsi esperienziali per allenare le tue skills',
          description:
            "Ogni modulo che l'AI Playground propone tre tipologie di attività diverse, pensate per allenare le soft skills da più angolazioni. Potrai scegliere tra contenuti rapidi, stimoli dinamici e sfide immersive: scarica la brochure completa per avere più informazioni.",
          blocks: {
            block1: {
              title: 'Pillole brevi',
              description:
                'Quiz, tool AI e micro-contenuti perfetti per attivare la mente, scoprire approcci nuovi e acquisire strumenti subito applicabili.',
            },
            block2: {
              title: 'Corner dinamici',
              description:
                'Mini-sessioni guidate da mentor, pensate per farti vedere le skill “in azione”. Un modo concreto per accendere idee e trasformare concetti in pratica.',
            },
            block3: {
              title: 'Game day',
              description:
                'Escape room, challenge a tempo e simulazioni. Per imparare facendo, allenare il mindset e mettere alla prova le tue reazioni.',
            },
          },
        },
        aiPlayground: {
          title: 'AI Playground',
          subTitle: "Vuoi partecipare a uno o più moduli dell'AI Playground?",
          description:
            'Esprimi il tuo interesse con un “mi piace”: l’HR vedrà le tue preferenze e potrà\n attivare i percorsi più rilevanti per te.',
          buttonLabel: 'Contattaci',
        },
      },
    },
  },
};
